/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class AbstractData
 */
export abstract class AbstractData {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public constructor(plain: {[key: string]: any} = {}) {
    this.fromPlain(plain);
  }

  public defined(property: string): boolean {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    return typeof this[property] !== 'undefined';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public modify(prop: string, callback: (prop: any) => any): this {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this[prop] = callback(this[prop]);
    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fromPlain(plain: {[key: string]: any}): this {
    for (const key of Object.keys(plain)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this[key] = plain[key];
    }

    return this;
  }
}
